// public record VehicleApiModel(string Id, FormFactor FormFactor, PropulsionType PropulsionType, double Latitude, double Longitude, int CurrentRangeInMeters, int MaxRangeMeters, string RentalUriAndroid, string RentalUriIos, string LastReported)

import { FormFactor } from '../../../models/labs/micromobility/form-factor.enum';
import { PropulsionType } from '../../../models/labs/micromobility/propulsion-type.enum';
import { IVehicle } from '../../../models/labs/micromobility/vehicle.model';

export class VehicleApiModel {
  public id!: string;
  public operatorName!: string;
  public formFactor!: FormFactor;
  public propulsionType!: PropulsionType;
  public latitude!: number;
  public longitude!: number;
  public currentRangeInMeters!: number;
  public maxRangeInMeters!: number;
  public rentalUriAndroid!: string;
  public rentalUriIos!: string;
  public lastReported!: string;

  public static mapToBusinessModel(apiModel: VehicleApiModel): IVehicle {
    return {
      id: apiModel.id,
      operatorName: apiModel.operatorName,
      formFactor: apiModel.formFactor,
      propulsionType: apiModel.propulsionType,
      latitude: apiModel.latitude,
      longitude: apiModel.longitude,
      currentRangeInMeters: apiModel.currentRangeInMeters,
      maxRangeInMeters: apiModel.maxRangeInMeters,
      rentalUriAndroid: apiModel.rentalUriAndroid,
      rentalUriIos: apiModel.rentalUriIos,
      lastReported: apiModel.lastReported,
    };
  }
}
